<template>
    <li v-if="video.video_title && video.video_start_time" class="staff-expand-header expand-header tb-expander telethon-expander noselect" :class="currentlyPlaying && 'green'" @click="toggle = !toggle">
        <div class="grid-container c2">
            <span class="staff-position text-condensed text-uppercase" :class="currentlyPlaying && 'bold'">
                {{ currentlyPlaying ? 'NOW' : video.video_start_time }}
            </span>
            <span class="staff-name text-left">{{ video.video_title }}</span> 
        </div>
        <prismic-rich-text :field="video.video_description" class="expander tb-video-description" :class="{ 'is-open': toggle }"/>
    </li>
</template>

<script>
export default {
    props: {
        video: Object,
        currentVideo: [Boolean, Object]
    },

    computed: {
        currentlyPlaying () {
            if (this.currentVideo.video_title === this.video.video_title && this.currentVideo.video_start_time === this.video.video_start_time) {
                return true;
            }
        }
    },
    
    data () {
        return {
            toggle: false,
            now: false
        }
    }
}
</script>

<style>
    .tb-expander {
        padding: 16px 0px;
        border: 1px black solid;
        padding: 16px;
        margin-bottom: 8px;

    }

    .tb-expander:hover{background-color: yellow !Important;}
    .tb-expander:after{opacity: 0 !important;}

    .tb-video-description p {
        margin: 8px 0px;
        font-size: 1.125vw;
    }

    .bold {
        font-family: 'Helvetica-Rounded'
    }

    .green {
        color: var(--green);
        border-bottom: 1px solid var(--green);
    }

    .green:after {
        border: none;
    }

    .tb-expander .staff-name {
        font-weight: normal;
    }

    .telethon-expander .expander.is-open{
        display: block;
            margin-top: 16px;
            margin-bottom: 0px;
            border: 1px black solid;
            padding: 48px;
            /* border-top: 1px black dotted; */
            background-color: yellow;
    }

    .telethon-expander .expander.is-open strong{
        color: black !important;
        font-weight: normal !important;
        text-transform: uppercase !important;
    }


    @media screen and (min-width: 768px) {
        .telethon-expander .grid-container.c2{
            grid-template-columns: 25% 75%;
        }
    }

</style>